import styled, { css } from 'styled-components';
import { Input, Input as AntInput, InputNumber } from 'antd';
import { COLORS, DEVICES, pickThemeFontSize, pickThemeFontStyles } from '@/theme';

export const inputStyles = css`
  width: 100%;
  background: ${COLORS.WHITE};
  color: ${COLORS.BLACK_PRIMARY};
  border: 1px solid ${COLORS.SOFT_GRAY};
  border-radius: 0.375rem;
  height: 2.125rem;
  ${pickThemeFontStyles('14', '20')};
  :hover {
    border: 1px solid ${COLORS.CHARCOAL};
  }
  ${pickThemeFontStyles('14', '22', 'BOLD')};

  &.ant-input,
  .ant-input-password {
    width: 100%;
    padding: 0.25rem 1rem !important;
    background: ${COLORS.LIGHTEST_GRAY};
  }

  &.ant-input-affix-wrapper {
    overflow: hidden;
    padding: 0;

    & .ant-input {
      padding: 0.25rem 1rem !important;
      background: ${COLORS.LIGHTEST_GRAY};
      ${pickThemeFontStyles('14', '20')};
    }

    & .ant-input-suffix {
      font-size: ${pickThemeFontSize('20')};
      margin: 0;
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
    }

    & .ant-input-prefix {
      font-size: ${pickThemeFontSize('20')};
      margin: 0;
    }
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &.ant-input {
      ${pickThemeFontStyles('16', '24')};
    }

    &.ant-input-affix-wrapper {
      & .ant-input {
        ${pickThemeFontStyles('16', '24')};
      }
    }
  }
`;

export const StyledInput = styled(AntInput)`
  ${inputStyles};
`;

export const StyledInputNumber = styled(InputNumber)`
  &.ant-input-number {
    width: 100%;
    border: 1px solid ${COLORS.SOFT_GRAY};
    background: ${COLORS.LIGHTEST_GRAY};

    & .ant-input-number-input-wrap {
      & input {
        color: ${COLORS.DARKEST_GRAY};
      }
    }
  }
`;

export const StyledPasswordInput = styled(AntInput.Password)`
  &&& {
    ${inputStyles};
    &&&& .ant-input-affix-wrapper {
      padding: 0 !important;
    }

    .ant-input {
      padding: 0.25rem 1rem !important;
    }
  }
`;

export const StyledTextArea = styled(Input.TextArea)`
  ${inputStyles}
`;

export const StyledList = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
`;

export const StyledTag = styled.div`
  ${pickThemeFontStyles('14', '16', 'SEMI_BOLD')};
  text-align: start;
  width: fit-content;
  background: ${COLORS.DARK_GRAY};
  color: ${COLORS.WHITE};
  padding: 0.75rem;
  border-radius: 99em;
  height: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  button {
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${COLORS.WHITE};
  }
`;
